import styled from "styled-components"

const Wrapper = styled.div`
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    span {
        color: var(--white, #FFF);
        text-align: center;
        font-family: var(--font-circular);
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 140%; /* 19.6px */
        letter-spacing: 0.14px;
        text-transform: capitalize;
        display: block;
        margin-bottom: 8px;
    }
`;

const Bar = styled.div`
    width: 238px;
    height: 24px;
    flex-shrink: 0;
    position: relative;
    border: 1px solid #E6D2A6;
    border-radius: 4px;
    background: #E6D2A6;
    overflow: hidden;

    .progressBar {
        background: linear-gradient(180deg, #AB8C57 0%, #FFF6ED 100%);
        border-radius: 3px;
        height: 100%;
        transition: width 0.3s ease;
    }
`;

type Props = {
    style?: React.CSSProperties | undefined,
    className?: string | undefined, 
    progress?: number;
    label?: string;
    labelClass?: string,
}

export const ProgressBar = ({ style, className, progress, label, labelClass }: Props ) => {

    let innerProgress = progress;
    if( progress === undefined || progress < 0)
        innerProgress = 0;
    else if( progress > 100)
        innerProgress = 100;

    return (
        <Wrapper>
            { label !== undefined ? <span className = {labelClass}>{ label }</span> : null }
            <Bar style = { style } className = { className }>
                <div style = {{width: `${ innerProgress }%`}} className = "progressBar" />
            </Bar>
        </Wrapper>
    )
}
